import { Outlet } from 'react-router-dom';

export function HeadlessLayout() {
  return <Outlet />;
}
